module.exports = "<footer class=\"app-footer\">\r\n  <span>{{ app_name }}</span>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/core/components/layout/footer/footer.component.html
// module id = ../../../../../src/app/core/components/layout/footer/footer.component.html
// module chunks = main